module.exports = __webpack_public_path__ + "static/media/landscape-cropx2.e6f11251.webp";